import { z } from "zod";
import formatStringNumberToNumber from "../components/utils/formatStringNumberToNumber";

const formEditRealiziranaVrednostSchema = z
  .object({
    realiziranaVrednost: z.preprocess(
      (value) => formatStringNumberToNumber(value),
      z.number().nullable().optional(),
    ),
    realiziraniProjektniViri: z.preprocess(
      (value) => formatStringNumberToNumber(value),
      z.number().nullable().optional(),
    ),
  })
  .superRefine(({ realiziranaVrednost, realiziraniProjektniViri }, ctx) => {
    if (realiziraniProjektniViri > realiziranaVrednost) {
      ctx.addIssue({
        message:
          "Sofinanciranje iz projektnega vira ne sme presegati vrednosti projekta",
        path: ["realiziranaVrednost"],
      });
    }
  });

export default formEditRealiziranaVrednostSchema;
